module.exports = __webpack_public_path__ + "static/media/MC.6298c9b4.png";